import axios from "axios";
import { getToken } from "@clerk/react";

export const api = axios.create({
  baseURL: "/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Clerk's session token (60 s; Clerk caches it and refreshes it in the background, before it expires). A signed-out
// user never gets here: Clerk's auth state sends the router to /sign-in.
api.interceptors.request.use(async (config) => {
  const token = await getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
